/**
 * @packageDocumentation
 * @module f1/is
 */

class PDB {
  readonly url = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i;
  readonly date = /^(1[0-2]|0?[1-9])([\/-])(3[01]|[12][0-9]|0?[1-9])(?:\2)(?:[0-9]{2})?[0-9]{2}$/;
  readonly time = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/;
  readonly affirmative = /^(?:1|t(?:rue)?|y(?:es)?|ok(?:ay)?)$/;
  readonly hex_color = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
  readonly hexadecimal = /^(?:0x)?[0-9a-fA-F]+$/;
  readonly zip_code = /^[0-9]{5}(?:-[0-9]{4})?$/;
  readonly alpha_numeric = /^[A-Za-z0-9]+$/;
  readonly alpha = /^[A-Za-z]+$/;
  readonly numeric = /^\d+$/;
}

const pDB = new PDB();

export interface IsPattern {
  /**
   * Match a string against a regular expression pattern
   *
   * @public
   * @function f1.is.pattern
   * @example
   *
   * ```ts
   * f1.is.pattern('alpha', 'abcd-1234') => false
   * f1.is.pattern('numeric', 'abcd-1234') => false
   * f1.is.pattern('alpha_numeric', 'abcd-1234') => true
   *
   * f1.is.pattern.db['my_pattern'] = /test/;
   * f1.is.pattern('my_pattern', 'test') => true
   * f1.is.pattern('my_pattern', 'test again') => false
   * ```
   */
  <R extends keyof PDB>(regName: R, regexp: string): boolean;
}

/**
 * @see IsPattern
 */
function is_pattern<R extends keyof PDB>(regName: R, regexp: string) {
  return pDB[regName].test(regexp);
}

is_pattern.db = pDB;
export default is_pattern;
